import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Store } from '@ngrx/store';

import {OptInSettings, User} from '../model';
import { UserActions } from '../store/actions';
import { AppStore } from '../store/app.store';
import { OrgIdService } from './org-id.service';
import {map} from 'rxjs/operators';

const PNF = require('google-libphonenumber').PhoneNumberFormat;
const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

function standardizePhoneNumber(_num:string) {
  const num = (_num || '').trim();
  if (num.length === 0) return '';

  try {
    const number = phoneUtil.parseAndKeepRawInput(num, 'US');
    const result = phoneUtil.format(number, PNF.E164);
    if ((result.length < 12) || (!result.startsWith('+1'))) {
      throw new Error('Invalid phone number');
    }
    return result;
  } catch (err) {
    console.log('Phone number invalid', num);
    throw err;
  }
}

@Injectable({
  providedIn: 'root'
})
export class OptInService {

  constructor(
    private db: AngularFireDatabase,
    private firebaseFunctions: AngularFireFunctions,
    private userActions: UserActions,
    private store: Store<AppStore>,
    private orgIdService: OrgIdService,
    private router: Router) {
  }

  loadForOrg(orgId: string): Observable<OptInSettings|null> {
    return this.db.object(`/optins/${orgId}`)
      .snapshotChanges()
      .pipe(map(snapshot => {
        const val: any = snapshot.payload.val();
        if (val) {
          return {
            orgName: val.orgName,
            description: val.description,
            logo: val.logo,
          };
        } else {
          return null;
        }
      }));
  }

  async saveOptIn(data: { orgId: string, number: string }): Promise<boolean> {
    console.log('Opt-in', data);
    const num = standardizePhoneNumber(data.number);

    if (num) {
      await this.db.object(`/optins-processed/${data.orgId}/${num}`).set({ at: new Date().getTime() });
      return true;
    }

    return false;
  }
}
